<template>
  <div class="page-err404">
    <div class="err404-title">
      您访问的页面找不到，请输入正确的地址~
    </div>
  </div>

</template>
<script>
  import SERVER from '@/config/config.ts'
  import URL from '@/config/server.ts'
  import { Message } from 'element-ui';
  import router from '@/router'
  import axios from 'axios'
  import qs from 'qs'
  export default {
    data() {
      return {
        sendCodeWord: '点击发送验证码',
        count: 60,
        isClick: true,
      }
    },
    beforeDestroy() {
      clearInterval(this.timer);
    },
    methods: {
      /**
       * 点击跳转
      */
      jump(value) {
        router.push({
          path: value,
        }).catch(err => {
          console.log(err)
        })

      },
      /**
       * 发送验证码
      */
      sendCode() {
        axios.post(SERVER.EBASE_URL+URL._ow_api_captcha_sms_code, {
          captchaInfo: {
            captchaType: 'OW_APPLY',
            code: this.$refs.code.value,
            mobile: this.$refs.mobile.value,
          }
        }).then((response) => {
          if (response.data.executed) {
            Message({
              message: '发送成功',
              type: 'success',
            });
            this.countDown();
          } else {
            Message({
              message: response.data.message,
              type: 'warning',
            });

          }
        }).catch(function (error) {
          console.log(error);
        });

      },
      /* 
      * 倒计时
      */
      countDown() {
        if (this.isClick) {
          this.isClick = false;
          this.sendCodeWord = this.count + 's';
          clearInterval(this.timer)
          this.timer = setInterval(() => {
            if (this.count > 1) {
              this.count--;
              this.sendCodeWord = this.count + 's';
            } else {
              this.sendCodeWord = '点击发送验证码';
              clearInterval(this.timer)
              this.isClick = true;
            }

          }, 1000);
        }

      },
      /**
     * 申请试用
    */
      applyTry() {
        axios.post(SERVER.EBASE_URL+URL._ow_api_save_apply, {
          captcha: this.$refs.code.value,
          saveApplyInfo: {
            companyName: this.$refs.companyName.value,
            customerName: this.$refs.customerName.value,
            mobile: this.$refs.mobile.value,
          }
        }).then(function (response) {
          if (response.data.executed) {
            Message({
              message: '申请成功,请等待工作人员与您联系。',
              type: 'success',
            });
          } else {
            Message({
              message: response.data.message,
              type: 'warning',
            });

          }
        }).catch(function (error) {
          console.log(error);
        });
      }

    },

  }
</script>
<style lang="sass">
  @import "./style.scss"
</style>